import { gql } from '@apollo/client/core';

const DealPreviewFragment = gql`
  fragment DealPreview on DealInterface {
    id
    closeDate
    amount
    isPrivateCompany
    isPrivateDepartments
    departments {
      id
      name
    }
    company {
      id
      name
    }
    post {
      id
      slug
      content {
        ... on DealStory {
          id
          text
        }
      }
    }
  }
`;

export default DealPreviewFragment;
